export default {"src":"/_next/static/media/person-person.26770dc2.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};